import { render, staticRenderFns } from "./SortableCorpEmissionByBizLoc.vue?vue&type=template&id=576d7696"
import script from "./SortableCorpEmissionByBizLoc.vue?vue&type=script&lang=js"
export * from "./SortableCorpEmissionByBizLoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports